import React from 'react';
import styled from 'styled-components';
import { MdClose } from 'react-icons/md';
import { AiOutlineFile } from 'react-icons/ai';
import PropTypes from 'prop-types';
import Text from 'components/styled/Text';
import { colors, FILE_TYPES } from '../../../../constants';
import { getFileSize } from 'utils/helpers';

const StyledFileItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const FileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const FileImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 4px;
`;

const FileVideo = styled.video`
  width: 48px;
  height: 48px;
  border-radius: 4px;
`;

const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const FileItem = ({ item, onRemoveFile }) => {
  const getFileSource = () => {
    const type = item.file.type.split('/')[0];
    switch (type) {
      case FILE_TYPES.IMAGE:
        return <FileImage src={item.source} alt="" />;
      case FILE_TYPES.VIDEO:
        return <FileVideo src={item.source} type={item.file.type} />;
      default:
        return <AiOutlineFile />;
    }
  };

  return (
    <StyledFileItem>
      <FileContainer>
        {getFileSource()}
        <FileInfo>
          <Text variant="body">{item.file.name}</Text>
          <Text variant="caption" color={colors.grey40}>
            {getFileSize(item.file)}
          </Text>
        </FileInfo>
      </FileContainer>
      <MdClose fill={colors.red} onClick={onRemoveFile} />
    </StyledFileItem>
  );
};

FileItem.propTypes = {
  item: PropTypes.object.isRequired,
  onRemoveFile: PropTypes.func.isRequired,
};

export default FileItem;
